export function getUpdatesPath(role?: string | null): string {
  switch (role) {
    case "EXPERT":
      return "/expert/updates";
    case "ECOSYSTEM_HEAD":
    case "ECOSYSTEM_SUBHEAD":
      return "/ecosystem-head/updates";
    case "FACILITATOR":
      return "/facilitator/updates";
    default:
      return "/updates";
  }
}
